import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { AxiosApi } from "../../helpers/AxiosApi";
import initialStates from "./state";

// Get Users List
export const getUserslist = createAsyncThunk(
  "getUserslist",
  async (
    { search, pageLimit, pageCount, sort_by, sort_direction },
    { rejectWithValue }
  ) => {
    try {
      let queryParams = [];

      if (search) queryParams.push(`search=${encodeURIComponent(search)}`);
      if (pageCount) queryParams.push(`page=${pageCount}`);
      if (pageLimit) queryParams.push(`limit=${pageLimit}`);
      if (sort_by) queryParams.push(`sortBy=${sort_by}`);
      if (sort_direction) queryParams.push(`sortOrder=${sort_direction}`);

      const queryString = queryParams.length ? `?${queryParams.join("&")}` : "";

      const response = await AxiosApi.get(`/auth/getAll-user${queryString}`);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data?.message);
      return rejectWithValue(error?.response?.data || error);
    }
  }
);
export const getAllUserslist = createAsyncThunk(
  "getAllUserslist",
  async (_, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.get(`/auth/get-users`);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data?.message);
      return rejectWithValue(error?.response?.data || error);
    }
  }
);
// Get Users List
export const getSingleUser = createAsyncThunk(
  "getSingleUser",
  async ({ habitLimit, habitPage, id }, { rejectWithValue }) => {
    try {
      let queryParams = [];

      if (habitPage) queryParams.push(`habitPage=${habitPage}`);
      if (habitLimit) queryParams.push(`habitLimit=${habitLimit}`);

      const queryString = queryParams.length ? `?${queryParams.join("&")}` : "";

      const response = await AxiosApi.get(`/auth/get-user/${id}${queryString}`);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

export const editUsers = createAsyncThunk(
  "editUsers",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.put(`/auth/update-user`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Delete Users
export const deleteUsers = createAsyncThunk(
  "deleteUsers",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.delete(`/auth/delete-user/${id}`);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

const usersSlice = createSlice({
  name: "users",
  initialState: initialStates,

  extraReducers: (builder) => {
    builder
      // get Users list
      .addCase(getUserslist.pending, (state) => {
        state.loading = true;
      })
      .addCase(getUserslist.fulfilled, (state, action) => {
        state.loading = false;
        state.getUserslistStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getUserslist.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // get All Users list
      .addCase(getAllUserslist.pending, (state) => {
        state.alluserloading = true;
      })
      .addCase(getAllUserslist.fulfilled, (state, action) => {
        state.alluserloading = false;
        state.getAllUserslistStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getAllUserslist.rejected, (state) => {
        state.alluserloading = false;
        state.error = true;
      })
      // get User
      .addCase(getSingleUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSingleUser.fulfilled, (state, action) => {
        state.loading = false;
        state.getSingleUserStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getSingleUser.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      //Edit Users
      .addCase(editUsers.pending, (state) => {
        state.loading = true;
      })
      .addCase(editUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.editUsersStatus.data = action.payload;
        state.error = false;
      })
      .addCase(editUsers.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })

      // Delete Users
      .addCase(deleteUsers.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.deleteUsersStatus.data = action.payload;
        state.error = false;
      })
      .addCase(deleteUsers.rejected, (state) => {
        state.loading = false;
        state.error = true;
      });
  },
});

export const { setUsers } = usersSlice.actions;
export default usersSlice.reducer;
